import {connect} from 'react-redux';
import {Graphics as Component} from './Graphics';
import {lightToggleIsOn} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {
  return {
    id: ownProps.id,
    type: state.notebook.protocolSection.scene.apparatus.light[ownProps.id-1].type,
    isOn: state.notebook.protocolSection.scene.apparatus.light[ownProps.id-1].isOn
  }
}

function mapDispatchToProps(dispatch) {
  return {
    toggleIsOn: (data)=>{
      dispatch(lightToggleIsOn(data))
  },};
}

export const Graphics = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
